import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import qs from 'qs';
import ErrorModal from "./ErrorModal"; // Import the ErrorModal
import logo from "../../assets/images/logo-win-white.svg";
import loginImage01 from "../../assets/images/login/login-page-image-01.jpg";
import loginImage02 from "../../assets/images/login/login-page-image-02.jpg";
import loginImage03 from "../../assets/images/login/login-page-image-03.jpg";
import { Endpoints } from "../../Global/Endpoints";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [showLoginButton, setShowLoginButton] = useState(false);
    const [showModal, setShowModal] = useState(false); // Modal visibility
    const [modalMessage, setModalMessage] = useState(""); // Modal message
    const [isLoading, setIsLoading] = useState(false); // Loading state
      const location = useLocation();
    const allReadyExist = location.state?.email || ""; // Get email from navigation state if present
    const navigate = useNavigate();
useEffect(() => {
  if (allReadyExist) {
    setEmail(allReadyExist);
  }
}, [allReadyExist]);
    // Email validation function
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // Handle email input change
    const handleEmailChange = (e) => {
        const inputEmail = e.target.value;
        setEmail(inputEmail);
        
        // If email is empty, show a "Please enter an email" error
        if (!inputEmail) {
            setError(t("forgotemailvalidation"));
        } 
        // If email is invalid, show a "Please enter a valid email" error
        else if (!validateEmail(inputEmail)) {
            setError(t("forgotvalidemailaddress"));
        } 
        // Clear error if the email is valid
        else {
            setError("");
        }
    
        // Clear success message when email changes
        if (successMessage) {
            setSuccessMessage("");
        }
    };
    

    // Handle password recovery
    const handleRecoverPassword = async () => {
        // Check if the email is empty
        if (!email) {
            setError(t("forgotemailvalidation"));
            return;
        }

        // Validate email format
        if (!validateEmail(email)) {
            setError(t("forgotvalidemailaddress"));
            return;
        }

        setIsLoading(true); // Set loading state
        try {
            const payload = qs.stringify({
                _Params: JSON.stringify({
                    EmailID: email,
                    FirstName: "",
                    LastName: "",
                    DeviceType:"PatientPortal"
                })
            });
            const response = await axios.post(
                Endpoints.ForgotPassword,
                payload,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    }
                }
            );

            setIsLoading(false); // Stop loading

            if (response.data.Result === 1) {
                setSuccessMessage(response.data.Message);
                setShowLoginButton(true);
            } else {
                setModalMessage(response.data.Message); // Set error message for modal
                setShowModal(true); // Show modal
            }
        } catch (err) {
            setIsLoading(false); // Stop loading in case of an error
            setModalMessage(t("errormessage"));
            setShowModal(true); // Show modal
        }
    };

    // Handle navigating to login
    const handleLogin = () => {
        navigate("/");
    };

    // Close the modal
    const closeModal = () => {
        setShowModal(false);
        setModalMessage("");
    };

    // Initialize carousel on component mount
    useEffect(() => {
        const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
        
        if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
            interval: 5000, // Set interval in milliseconds
        });
        }
    }, []);
    const handleBackClick = () => {
        navigate(-1); // Redirects to the home page
      };
    return (
        <div className="login-main">
            <header>
                <nav className="navbar navbar-expand-lg container-fixed">
                    <a className="navbar-brand" href="#">
                        <img src={logo} alt="Logo" className="logo" />
                    </a>
                </nav>
            </header>

            <div className="login-block-main">
                <div className="login-image-wrapper">
                    <div
                        id="carouselExampleSlidesOnly"
                        className="carousel slide"
                        data-bs-ride="carousel"
                    >
                        <div className="carousel-inner">
                            <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                                <img src={loginImage01} alt="" className="login-image" />
                            </div>
                            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                                <img src={loginImage02} alt="" className="login-image" />
                            </div>
                            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                                <img src={loginImage03} alt="" className="login-image" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="login-form-main">
                    <div className="forgot-form">
                        <h2 className="page-heading text-center">{t("forgotpasswordtitle")}</h2>
                        <div className="mb-2">
                            <label htmlFor="txtFirstName" className="form-label win-form-label">
                               {t("forgotdescription")}
                              </label>
                            <input
                                type="email"
                                className="form-control win-form-control w-100 mt-2"
                                id="email"
                                placeholder={t("forgotemailaddress")}
                                value={email}
                                onChange={handleEmailChange}
                                maxLength={100}
                                required
                                autoComplete="off"
                            />
                            {error && <div className="form-field-error-message">{error}</div>}
                            <button
                                onClick={handleRecoverPassword}
                                type="submit"
                                className="win-btn-primary mt-4 mb-2  me-3"
                                disabled={isLoading} // Disable button when loading
                            >
                                {isLoading ? t("sending") : t("recoverpassword")}
                            </button>
                            
                            <button className="win-btn-secondary" onClick={handleBackClick}>{t("Back")}</button>
                         
                            
                            {successMessage && <label className="form-label win-form-label mt-4">{successMessage}</label>}
                            {showLoginButton && (
                                <button onClick={handleLogin} type="submit" className="win-btn-primary mt-4">
                                    {t("Login")}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ErrorModal show={showModal} message={modalMessage} onClose={closeModal} />
        </div>
    );
};

export default ForgotPassword;
